
<div class="container-fluid" *ngIf="_SettingsService.formHideShow==0">
    <div id="form-wrap">
        <h2 class="heading_all">DOCUMENT SETTING</h2>
        <br>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
            <div class="col-md-4 ">

                <table>
                    <thead>
                        <tr>
                            <td>
                                <button type="button" class="btn-sm btn-info" (click)="addNew()"><i class="fas fa-plus"
                                        aria-hidden="true"></i></button>
                            </td>
                            <td style="width:60%;"><input type="text" class="form-control-search" name="search"
                                    [(ngModel)]="term"></td>
                            <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <th class="hidden-xs" style="width:205px;">
                        <div class="AtjIsPoint" (click)="sort('Code')">
                            <span *ngIf="!_SettingsService.isFiltering">Code</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_SettingsService.orderByColName!='Code' "></i>
                                <div *ngIf="_SettingsService.orderByColName=='Code'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_SettingsService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_SettingsService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_SettingsService.isFiltering">
                            <input type="text" #txtCodeFilter="ngModel" [(ngModel)]="_SettingsService.CodeFilter"
                                placeholder="Code">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Employee')">
                            <span *ngIf="!_SettingsService.isFiltering">Employee</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_SettingsService.orderByColName!='Employee' "></i>
                                <div *ngIf="_SettingsService.orderByColName=='Employee'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_SettingsService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_SettingsService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_SettingsService.isFiltering">
                            <input type="text" #txtEmployeeFilter="ngModel"
                                [(ngModel)]="_SettingsService.EmployeeFilter" placeholder="Employee">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Module')">
                            <span *ngIf="!_SettingsService.isFiltering">Module</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_SettingsService.orderByColName!='Module' "></i>
                                <div *ngIf="_SettingsService.orderByColName=='Employee'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_SettingsService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_SettingsService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_SettingsService.isFiltering">
                            <input type="text" #txtModuleFilter="ngModel"
                                [(ngModel)]="_SettingsService.ModuleFilter" placeholder="Module">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('DocName')">
                            <span *ngIf="!_SettingsService.isFiltering">File Name</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_SettingsService.orderByColName!='DocName' "></i>
                                <div *ngIf="_SettingsService.orderByColName=='Employee'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_SettingsService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_SettingsService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_SettingsService.isFiltering">
                            <input type="text" #txtDocNameFilter="ngModel"
                                [(ngModel)]="_SettingsService.DocNameFilter" placeholder="File Name">
                        </div>
                    </th>
                    <th style="width: 135px;"><em></em> Settings
                        <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                            <i *ngIf="!_SettingsService.isFiltering" class="fas fa-filter"></i>
                            <i *ngIf="_SettingsService.isFiltering" class="fas fa-times"></i>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let obj of _SettingsService.allDocumentSetting | orderBy : 'Code' | gridOperations  :_SettingsService.pageIndex: 
                     {Code:_SettingsService.CodeFilter,Employee:_SettingsService.EmployeeFilter,
                      Module:_SettingsService.ModuleFilter,FileName:_SettingsService.DocNameFilter}:
                    {Column:_SettingsService.orderByColName,Dir:_SettingsService.orderByDir} ; let i = index"
                    class="ng-scope">
                    <td>{{i+1+((NoOfItems*_SettingsService.pageIndex)-NoOfItems)}}</td>
                    <td style="width:205px;">{{obj.Code}}</td>
                    <td title="{{obj.Employee}}">{{obj.Employee}}</td>
                    <td title="{{obj.Module}}">{{obj.Module}}</td>
                    <td title="{{obj.FileName}}">{{obj.FileName}}</td>
                    <td style="width: 135px;">
                        <button type="button" class="btn-success" (click)="OnEdit(obj);">
                            <i class="fas fa-pen-square" aria-hidden="true"></i></button>
                        <button type="button" class="btn-danger" (click)="onDelete(obj.ID)"><i
                                class="fas fa-trash" aria-hidden="true"></i></button>
                    </td>
                </tr><!-- end ngRepeat: item in items -->
                <tr>
                    <td colspan="4"
                        *ngIf="(_SettingsService.allDocumentSetting?.length<=0 )  || _CommonService.filterdItemCount<1">
                        No Records To Display.</td>
                </tr>
            </tbody>
            <tfoot>
                <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                    <app-grid-pagination (pageIndexValue)="_SettingsService.pageIndex=$event"></app-grid-pagination>
                </td>
            </tfoot>
        </table>
        <div class="margintop"></div>
    </div>
</div>
<app-delete-confirm *ngIf="deletePopUp" [title]="'DOCUMENT SETTING'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>